import { createDisplayFieldPicker } from '@/utils/rowCacheSync';

/** Shared column config for contacts list and company Contacts tab. */
export const RELATIONSHIP_CONTACT_HEAD_CELLS = [
	{ id: 'fullName', numeric: false, label: 'Name', align: 'left', hideable: false },
	{ id: 'email', numeric: false, label: 'Email', align: 'left' },
	{ id: 'relationshipType', numeric: false, label: 'Type', align: 'left' },
	{ id: 'referralCount', numeric: true, label: 'Referrals', align: 'left', sortable: false },
	{ id: 'roleTitle', numeric: false, label: 'Role', align: 'left' },
	{ id: 'firstName', numeric: false, label: 'First name', align: 'left' },
	{ id: 'lastName', numeric: false, label: 'Last name', align: 'left' },
	{ id: 'mobile', numeric: false, label: 'Mobile', align: 'left' },
	{ id: 'lastContactedAt', numeric: false, date: true, label: 'Last contacted', align: 'left' },
	{ id: 'nextActionDate', numeric: false, date: true, label: 'Next action date', align: 'left' },
	{
		id: 'nextActionDescription',
		numeric: false,
		label: 'Next action description',
		align: 'left',
	},
	{ id: 'notesSummary', numeric: false, label: 'Notes', align: 'left' },
	{ id: 'lastUpdated', numeric: false, date: true, label: 'Last updated', align: 'left' },
	{ id: 'lastUpdatedBy', numeric: false, label: 'Last modified by', align: 'left' },
	{ id: 'relationshipStatus', numeric: false, label: 'Status', align: 'left' },
];

export const RELATIONSHIP_CONTACT_DEFAULT_HIDDEN_COLUMNS = [
	'relationshipStatus',
	'roleTitle',
	'firstName',
	'lastName',
	'mobile',
	'lastContactedAt',
	'notesSummary',
	'lastUpdated',
	'lastUpdatedBy',
];

/** Company tab mixes archived people, so status stays visible. */
export const RELATIONSHIP_COMPANY_CONTACT_DEFAULT_HIDDEN_COLUMNS =
	RELATIONSHIP_CONTACT_DEFAULT_HIDDEN_COLUMNS.filter((field) => field !== 'relationshipStatus');

/** Picks relationships InstantSearch table display fields from a cached contact. */
export const pickRelationshipContactDisplayFields = createDisplayFieldPicker({
	firstName: 'nullable',
	lastName: 'nullable',
	fullName: 'nullable',
	email: 'nullable',
	relationshipType: 'nullable',
	relationshipStatus: 'nullable',
	roleTitle: 'nullable',
	mobile: 'nullable',
	lastContactedAt: 'nullable',
	nextActionDate: 'nullable',
	nextActionDescription: 'nullable',
	notesSummary: 'nullable',
	lastUpdated: 'nullable',
	lastUpdatedBy: 'nullable',
});
